import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4acb90f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "LetterDropz")
], -1))
const _hoisted_3 = { class: "question-definition" }
const _hoisted_4 = { class: "letter-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "letter-list__letter" }
const _hoisted_7 = {
  key: 0,
  class: "correct"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h3", null, "Current Score: " + _toDisplayString(_ctx.currentScore), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.currentQuestion?.definition), 1),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.puzzle.letters.split(''), (letter, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass([
          'letter-list__item',
          {
            drop: _ctx.guessedLetterIndexes.includes(index),
            incorrect: _ctx.incorrectGuess,
          },
        ]),
          onClick: ($event: any) => (_ctx.guessLetter(index, letter))
        }, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(letter), 1)
        ], 10, _hoisted_5))
      }), 128))
    ]),
    _createElementVNode("button", {
      class: "reset-btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
    }, "RESET"),
    (_ctx.answeredCorrectly)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.correctWord) + "!", 1))
      : _createCommentVNode("", true)
  ]))
}